<app-loader></app-loader>
<h2 mat-dialog-title *ngIf="success == false">Create</h2>
<h2 mat-dialog-title *ngIf="success == true">Success</h2>
<mat-dialog-content class="mat-typography">
    <mat-card>
        <mat-card-content>
            <form *ngIf="success == false; else successMessage">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Name</mat-label>
                    <input matInput name="name" [(ngModel)]="createFolderFileObj.name">
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Destination</mat-label>
                    <input matInput name="destFolderId" [(ngModel)]="data.folder.name" disabled>
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Type</mat-label>
                    <input matInput name="fileType" [(ngModel)]="createFolderFileObj.fileType" disabled>
                </mat-form-field>
            </form>
            <ng-template #successMessage>
                The file/folder is successfully created and can be accesed using the link - <a href={{message}}
                    target="_blank">{{message}}</a>
            </ng-template>
        </mat-card-content>
    </mat-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button class="button-style" (click)="createInDrive()" *ngIf="success == false">Create</button>
    <button mat-raised-button class="button-style" [cdkCopyToClipboard]="message" *ngIf="success == true">Copy
        Link</button>
    <button mat-raised-button mat-dialog-close [mat-dialog-close]="success" class="button-style">Close</button>
</mat-dialog-actions>